import React, { useEffect, useState } from 'react';
import { getSrvCfg, SRV_CONFIG_KEY } from "../../utils/storage";
import "./EnvBanner.scss"

const EnvBanner = () => {
  const [envType, setEnvType] = useState(getSrvCfg().envType);

  useEffect(() => {
    function fromStorage(event) {
      if (event.key === SRV_CONFIG_KEY) {
        setEnvType(JSON.parse(event.newValue)?.envType);
      }
    }

    window.addEventListener("storage", fromStorage);
    return () => {
      window.removeEventListener("storage", fromStorage);
    };
  }, []);

  useEffect(() => {
    document.title += ` ${(envType === 0 && !document.title.includes("[DEV]") ? "[DEV]" : (envType === 1 && !document.title.includes("[TEST]") ? "[TEST]" : ""))}`;
  }, [envType]);

  switch (envType) {
    case 0:
      return (
        <div className='env-banner'>
          <div className='env-banner-text'>VÝVOJOVÉ PROSTREDIE</div>
        </div>
      );
    case 1:
      return (
        <div className='env-banner'>
          <div className='env-banner-text'>TESTOVACIE PROSTREDIE</div>
        </div>
      );
    default:
      return null;
  }
}

export default EnvBanner;